import React from 'react';

/**
 * Designed empty state used across the enterprise app in place of bare
 * "No data" text.
 */
export default function EntEmptyState({ icon, title, lead, action }) {
  return (
    <div className="ent-empty-state">
      {icon ? (
        <div className="ent-empty-state-icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}
      <p className="ent-empty-state-title">{title}</p>
      {lead ? <p className="ent-empty-state-lead">{lead}</p> : null}
      {action || null}
    </div>
  );
}
